const React = require('react'),
  {PropTypes} = require('react'),
  {t} = require('services/i18nextWrapper'),
  {map, some} = require('lodash/collection'),
  {merge} = require('lodash/object'),
  {delay} = require('lodash/function'),
  Notification = require('components/Notification/Notification'),
  {cloneDeep} = require('lodash/lang'),
  get = require('lodash/object').get,
  ContentUtils = require('utils/ContentUtils'),
  OrderUtils = require('utils/OrderUtils'),
  DateUtils = require('utils/DateUtils'),
  DashboardServiceCache = require('services/DashboardServiceCache'),
  ga = require('react-ga'),
  DashboardModalStore = require('stores/DashboardModalStore'),
  AppDispatcher = require('dispatcher/SchedulerAppDispatcher'),
  categories = require('constants/AppConstants').Analytics.categories,
  OrderStore = require('stores/OrderStore'),
  ActionTypes = require('constants/AppConstants').ActionTypes,
  {
      formatTasksProducts,
      getIndexTab,
      changeLabelNote,
      changeLabelName,
      cleanTasks,
      getTasksFromProcess,
      updateTask
  } = require('components/DashboardModal/DashboardModalUtils'),
  actions = require('constants/AppConstants').Analytics.actions,
  DashboardModalSingleBody = require('components/DashboardModal/DashboardModalSingleBody/DashboardModalSingleBody'),
  SessionStore = require('stores/SessionStore'),
  {
      isValidForm,
      onChangeFromDateEditMode,
      onChangeToDateEditMode,
      onChangeBeerStyle,
      getExistingModalState,
      onChangeVolume,
      onChangeTaskType,
      initializeSingleTasksEl,
      onDeleteTask,
      onChangeTask,
      onChangeTankEditMode,
      cleanModal
  } = require('stores/DashboardModalStore/DashboardModalSingleStore/DashboardModalSingleStore'),
  {Tab, Tabs} = require('material-ui'),
  {
      onChangeBrewTurnNew,
      initializeBrewingTurns,
      formatBatchs,
      onChangeProcess,
      someProductAlreadyConfirmed,
      onChangeBrewTurn,
      updateStateTask
  } = require('stores/DashboardModalStore/DashboardModalBrewStore/DashboardModalBrewStore'),
  {TIME_WAIT_MODAL_EXPAND} = require('constants/AppConstants'),
  InventoryStore = require('stores/InventoryStore');

const DashboardModalSingleChange = React.createClass({displayName: "DashboardModalSingleChange",

    propTypes: {
        close: PropTypes.function,
        initFromDate: PropTypes.object,
        orderDateClicked: PropTypes.string,
        openGeneralTab: PropTypes.boolean,
        onActiveFirstTab: PropTypes.function,
        sectionName: PropTypes.string,
        order: PropTypes.object,
        tankClicked: PropTypes.object
    },

    _refs: {
        beerStyle: null,
        singleType: null
    },

    componentWillMount() {
        let nextState = getExistingModalState(this.props, this.props.isBHAllowed, this.props.orderDateClicked);
        this.setState(nextState);

        // set temporary to find after update estimation inventory in each task
        this.orderId = get(this.props.order, 'id');

        // save the order safely to non change at dashboard level anything
        this.ordersCloned = cloneDeep(DashboardServiceCache.getOrdersSorted());
    },

    componentWillReceiveProps(nextProps) {
        let nextState = getExistingModalState(nextProps, nextProps.isBHAllowed, this.props.orderDateClicked);

        this.setState(nextState);
    },

    getInitialState() {
        return {
            isBeerStyleAlreadyDefined: true
        };
    },

    componentDidMount() {
        this.refs.refTabs.setState({
            // fix the bug when click on packaging side it does not open the packaging tab
            selectedIndex: getIndexTab(this.props)
        });
    },

    /**
     * This method will execute all validation needed for this form.
     *
     * @param nextState
     * @public
     * @returns {*}
     */
    isValidForm(prevState) {
        let nextState = merge(this.state, prevState);
        if (prevState && prevState.singleTank) {
            nextState.singleTank = prevState.singleTank;
        }
        return isValidForm(nextState, this._refs);
    },

    triggerValidation(nextState) {
        return this.isValidForm(nextState).messagesError;
    },

    /**
     * This method will add new single order.
     * @param afterSubmit
     */
    submit(parentRefs, afterSubmit) {
        const isValidResult = this.isValidForm(this.state);
        if (isValidResult && !isValidResult.isValid) {
            this.setState(isValidResult.messagesError, () => {
                if (this.refs.refTabs) {
                    this.refs.refTabs.setState({
                        selectedIndex: 0
                    });
                }
            });
            return;
        }

        let singleOrder = this.state.order;
        singleOrder.applicant = SessionStore.getCurrentApplicant();
        singleOrder.styleBeerId = this.state.styleBeerSelected.id;
        singleOrder.singleTank = this.state.singleTank;
        singleOrder.singleTankId = get(this.state, 'singleTank.tankObj.id', get(this.state, 'singleTank.id'));
        singleOrder.styleBeer = this.state.styleBeerSelected;
        singleOrder.fromDate = DateUtils.toDateText(this.state.fromDate);
        singleOrder.toDate = DateUtils.toDateText(this.state.toDate);
        singleOrder.comment = this.state.commentOrder;
        singleOrder.singleTasks = cleanTasks(
            ContentUtils.cleanAllTasksOfProducts(
                formatTasksProducts(this.state.singleTasks)));
        singleOrder.batchNumber = parentRefs.batchNumber.getValue();
        singleOrder.isSingle = true;
        singleOrder.volume = ContentUtils.getNumber(this.state.orderVolume);

        const batchs = ContentUtils.cleanAllTasksOfProducts(singleOrder.batchs);
        let isBHAllowed;

        if (get(singleOrder, 'singleTank.type') !== 'BH' && get(batchs, 'length', 0) > 0) {
            singleOrder.batchs = cleanTasks(formatTasksProducts(formatBatchs(batchs)));
            isBHAllowed = true;
        } else {
            singleOrder.batchs = [];
            isBHAllowed = false;
        }

        const onSuccess = () => {
            ga.event({
                category: categories.ORDER_SINGLE,
                action: actions.CHANGE,
                label: 'Applicant: ' + SessionStore.getCurrentApplicant() + ' User: ' + ContentUtils.getSession('userNameSession')
            });

            this.clean();

            afterSubmit();
        };

        const onFailure = errorMessage => this.setState({volumenTankMessageError: errorMessage});

        OrderStore.changeSingleOrderWithoutCheck(singleOrder, onSuccess, onFailure, isBHAllowed, DashboardModalStore.getCurrentLayout());
    },

    clean() {
        cleanModal(this);
    },

    _onChangeFromDate(evt, fromDate) {
        if (!SessionStore.isAbleToEditDates()) {
            Notification.show(t('dashboard_notification_dont_enough_permission_section'));
            return;
        }
        if (OrderStore.existSomeProductConfirmed(this.state.order, this.state.fromDate, fromDate)) {
             Notification.show(t('notification_unconfirm_product_and_try_again'));
            return;
        }
        this.setState(previousState => {
            return onChangeFromDateEditMode(previousState, fromDate, this.props.isBHAllowed);
        });
    },

    _onChangeToDate(evt, toDate) {
        if (!SessionStore.isAbleToEditDates()) {
            Notification.show(t('dashboard_notification_dont_enough_permission_section'));
            return;
        }
        if (OrderStore.existSomeProductConfirmed(this.state.order, this.state.toDate, toDate)) {
             Notification.show(t('notification_unconfirm_product_and_try_again'));
            return;
        }
        this.setState(previousState => {
            return onChangeToDateEditMode(previousState, toDate, this.props.isBHAllowed);
        });
    },

    _onChangeBeerStyle(evt) {
        const beerStyleSelected = merge(evt, evt.itemModel);
        this.setState(previousState => {
            return onChangeBeerStyle(previousState, beerStyleSelected, previousState.currentSection, this.props.isBHAllowed);
        }, () => {
            AppDispatcher.dispatch({
                type: ActionTypes.DASHBOARD_MODAL_CHANGE_BEER_STYLE,
                volume: this.state.orderVolume,
                batchNumber: this.state.batchNumber,
                order: this.state.order,
                isSingle: true
            });
        });
    },

    _onChangeTask(tasks, oldItemSelected, typeTask, dateTask, itemSelected, evt) {
        if (typeTask === 'BH' && !isSingleFromBrewingSection(this.state)) {
            this.setState(prevState => onChangeBrewTurnNew(oldItemSelected, dateTask, 'batchs', prevState, get(itemSelected, 'turnId'), itemSelected, itemSelected), () => {
                AppDispatcher.dispatch({
                    type: ActionTypes.DASHBOARD_MODAL_CHANGE_TASK_TYPE,
                    order: this.state.order
                });
            });
        } else {
            this.setState(prevState => onChangeTaskType(tasks, oldItemSelected, typeTask, dateTask, prevState, evt, itemSelected), () => {
                AppDispatcher.dispatch({
                    type: ActionTypes.DASHBOARD_MODAL_CHANGE_TASK_TYPE,
                    order: this.state.order
                });
            });
        }
    },

    _onDeleteTask(tasks, itemSelected, typeTask, dateTask) {
        this.setState(prevState => onDeleteTask(prevState.singleTasks, dateTask));
    },

    _onChangeAmountItem(productChanged, itemChanged, newAmount) {
        itemChanged.amount = newAmount;
        itemChanged.manualAmount = newAmount;
        itemChanged.item.amount = newAmount;

        // update the list of items from product
        const items = get(productChanged, 'items');
        const itemsChanged = ContentUtils.replace(items, itemChanged, 'id');
        productChanged.items = itemsChanged;

        return productChanged;
    },

    _onConfirmProduct(product, uniqueId, task) {
        // update the product instance of the task
        product.isSaved = false;
        this.setState(prevState => {
            let result = InventoryStore.onConfirmProduct(prevState, product, task, this.ordersCloned, this.temporaryOrderId);
            this.ordersCloned = result.ordersCloned;
            result.isSomeProductAlreadyConfirmed = true;
            result.ordersCloned = null;
            result = someProductAlreadyConfirmed(prevState);
            return result;
        }, () => {
            this._onChangeProducts(product, product.amount, uniqueId, task);
        });
    },

    _onChangeVolumeItem(product, newPorcent, uniqueId, task) {
        this._onChangeProducts(product, product.amount, uniqueId, task);
    },

    _onChangeAmountInLocation(task, productUpdated) {
        const avoidMultiplicateAmountItems = true;
        this._onChangeProducts(productUpdated, productUpdated.amount, '', task, avoidMultiplicateAmountItems);
    },

    _onChangeProducts(productWithoutChange, newAmount, uniqueId, task, avoidMultiplyItemByAmountProduct) {
        const taskType = get(task, 'sectionType');
        let taskWithProductUpdated;
        this.setState(prevState => {
            const endDateOrder = OrderUtils.getEndDateOrder(prevState.order);
            const nextState = InventoryStore.onChangeSingleProducts(this.ordersCloned, prevState, productWithoutChange, newAmount, uniqueId, task, avoidMultiplyItemByAmountProduct, endDateOrder);

            taskWithProductUpdated = nextState.taskWithProductUpdated;
            this.ordersCloned = nextState.ordersCloned;
            nextState.taskWithProductUpdated = null;
            nextState.ordersCloned = null; // not needed to put in set state context

            return nextState;
        }, () => {
            AppDispatcher.dispatch({
                type: ActionTypes.DASHBOARD_MODAL_CHANGE_PRODUCT_AMOUNT,
                newAmount,
                order: this.state.order,
                batchNumber: this.state.batchNumber,
                isSingle: true,
                taskType,
                taskUpdated: task,
                taskWithProductUpdated
            });
        });
    },

    _onBlurLabelOrDescription(tasks, itemSelected, typeTask, dateTask, field, evt) {
        const targetValue = get(evt, 'target.value', '');
        this.setState(prevState => onChangeTask(targetValue, prevState.singleTasks, dateTask, field));
    },

    _notifyToParentIfVolumeAlreadyChanged(prevState, nextState, props) {
        if (prevState.orderVolume !== nextState.orderVolume) {
            props.onChangeVolume(prevState, nextState);
        }
    },

    _onChangeTank(evt, index, menuItem) {
        this.setState(prevState => {
            let nextState = onChangeTankEditMode(prevState, menuItem);
            nextState = merge(nextState, this.triggerValidation(nextState));
            return nextState;
        });
    },

    _initializeTasks(currentListedTaskTypeSelected) {
        return initializeSingleTasksEl(currentListedTaskTypeSelected, this);
    },

    _existSomeTaskByDate(date) {
        return some(this.state.singleTasks, task => get(task, 'date') === DateUtils.toDateText(date));
    },

    _onChangeVolume(evt) {
        const volume = get(evt, 'target.value');
        this.setState(prevState => {
                let nextState = onChangeVolume(prevState, volume, this.props.isBHAllowed);
                return nextState;
            }, () => {
                AppDispatcher.dispatch({
                    type: ActionTypes.DASHBOARD_MODAL_CHANGE_VOLUME,
                    batchNumber: this.state.batchNumber,
                    volume,
                    order: this.state.order,
                    isSingle: true
                });
            }
        );
    },

    _onChangeComment(evt) {
        const commentOrder = get(evt, 'target.value');
        this.setState({
            commentOrder
        });
    },

    _onChangeBrewingTaskType(oldItemSelected, turnDate, fieldName, turnId, newMenuItemSelected) {
        const targetValue = get(newMenuItemSelected, 'payload');
        this.setState(prevState => onChangeBrewTurnNew(oldItemSelected, turnDate, fieldName, prevState, turnId, targetValue, newMenuItemSelected), () => {
            AppDispatcher.dispatch({
                type: ActionTypes.DASHBOARD_MODAL_CHANGE_TASK_TYPE,
                order: this.state.order
            });
        });
    },

    _onChangeNote(oldItemSelected, typeTask, dateTask, evt) {
        const targetValue = get(evt, 'target.value');
        const itemSelectedUpdated = changeLabelNote(oldItemSelected, targetValue);
        this.setState(updateStateTask(this.state, itemSelectedUpdated));
    },

    _onChangeName(oldItemSelected, typeTask, dateTask, evt) {
        const targetValue = get(evt, 'target.value');
        const itemSelectedUpdated = changeLabelName(oldItemSelected, targetValue);
        this.setState(updateStateTask(this.state, itemSelectedUpdated));
    },

    _onChangeProcess(newProcessOrder) {
        const tasks = getTasksFromProcess(newProcessOrder, this.state);
        const result = onChangeProcess(this.state, newProcessOrder.existingProcess, newProcessOrder, tasks);
        this.setState(result);
    },

    _onChangeCloseOrder() {
        this.setState(prevState => {
            let order = get(prevState, 'order');
            order.closed = !order.closed;
            return {
                order
            };
        });
    },

    _onToggleExpand(existingTask) {
        delay(() => {
            const hydratedTask = InventoryStore.hydrateTaskWithProducts(existingTask, get(this.state, 'styleBeerSelected.id'));
            this._updateExistingTask(hydratedTask);
        }, TIME_WAIT_MODAL_EXPAND);
    },
    
    _updateExistingTask(updatedTask) {
        if (SessionStore.isFullPaidVersion()) {
            if (updatedTask.sectionType === 'BREWHOUSE_TASK') {
                this.setState(prevState => {
                    prevState.batchs = updateTask(prevState.batchs, updatedTask);
                    prevState.order.batchs = prevState.order.batchs;
                    return prevState;
                });
            } else {
                this.setState(prevState => {
                    prevState.order.singleTasks = updateTask(prevState.order.singleTasks, updatedTask);
                    prevState.singleTasks = prevState.order.singleTasks;
                    return prevState;
                });
            }
        }
    },

    render() {
        const currentTabOpen = getIndexTab(this.props);
        const {isBHAllowed, isBTAllowed, isFVAllowed} = this.props;

        let brewingTab, tabsContent;

        const currentTaskTypeSelected = get(this.state, 'listedTaskTypeSelected.type');
        const tasks = this._initializeTasks(currentTaskTypeSelected);
        const bodyContent = (
            React.createElement(DashboardModalSingleBody, {
                tankTypeClicked: this.props.tankTypeClicked, 
                initFromDate: this.props.initFromDate, 
                onChangeCloseOrder: this._onChangeCloseOrder, 
                initToDate: DateUtils.addDays(this.props.initFromDate, 1), 
                parentState: this.state, 
                sectionName: this.props.sectionName, 
                onChangeFromDate: this._onChangeFromDate, 
                onChangeToDate: this._onChangeToDate, 
                onChangeBeerStyle: this._onChangeBeerStyle, 
                onChangeTank: this._onChangeTank, 
                onChangeVolume: this._onChangeVolume, 
                onChangeComment: this._onChangeComment, 
                refsSubscriber: this._refs}
            )
        );

        const isSingleWithoutBrewingSection = isBHAllowed === false || isBHAllowed && !isFVAllowed && !isBTAllowed;
        const batchs = get(this.state, 'order.batchs');

        if (isSingleWithoutBrewingSection || !batchs) {
            tabsContent = (
                React.createElement(Tabs, {className: "modal-order-dialog", 
                      ref: "refTabs", 
                      initialSelectedIndex: currentTabOpen}, 
                    React.createElement(Tab, {onActive: this.props.onActiveFirstTab, label: t('dashboard_modal_tab_general')}, 
                        React.createElement("div", {className: "modal-order-container fluid-container"}, 
                            bodyContent
                        )
                    ), 
                    React.createElement(Tab, {onActive: this.props.onActiveFirstTab, label: this.props.sectionName}, 
                        React.createElement("div", {className: "modal-order-task-container container-fluid"}, 
                            React.createElement("ul", {className: "modal-order-task-list container-fluid"}, 
                                tasks
                            )
                        )
                    )
                )
            );

        } else if (get(batchs, 'length') === 0) {
            brewingTab = (
                React.createElement(Tab, {onActive: this.props.onActiveFirstTab, label: t('dashboard_modal_tab_brewing')}, 
                    React.createElement("div", {className: "modal-order-task-container"}, 
                        React.createElement("br", null), 
                        React.createElement("div", {className: "modal-order-task-list container-fluid text-center"}, 
                            React.createElement("h5", null, t('dashboard_modal_order_volume_zero'))
                        )
                    )
                )
            );
            return (
                React.createElement(Tabs, {className: "modal-order-dialog", 
                      ref: "refTabs", 
                      initialSelectedIndex: currentTabOpen}, 
                    React.createElement(Tab, {onActive: this.props.onActiveFirstTab, label: t('dashboard_modal_tab_general')}, 
                        React.createElement("div", {className: "modal-order-container fluid-container"}, 
                            bodyContent
                        )
                    ), 
                    brewingTab, 
                    React.createElement(Tab, {onActive: this.props.onActiveFirstTab, label: this.props.sectionName}, 
                        React.createElement("div", {className: "modal-order-task-container container-fluid"}, 
                            React.createElement("ul", {className: "modal-order-task-list container-fluid"}, 
                                tasks
                            )
                        )
                    )
                )
            );

        } else if (get(batchs, 'length') > 0) {
            // sort batch in order to avoid issues ordering after change each batch task
            const sortedBatchs = map(batchs, batch => {
                batch.column = get(batch, 'turn.column');
                return batch;
            });
            const brewingTasks = initializeBrewingTurns(
                sortedBatchs,
                this._onChangeBrewingTaskType,
                this._onChangeProcess,
                this._onChangeProducts,
                this._onChangeAmountItem,
                this._onChangeVolumeItem,
                this._onChangeAmountInLocation,
                this.state.dataClicked,
                this._onConfirmProduct,
                this
            );

            brewingTab = (
                React.createElement(Tab, {onActive: this.props.onActiveFirstTab, label: t('dashboard_modal_tab_brewing')}, 
                    React.createElement("div", {className: "modal-order-task-container"}, 
                        React.createElement("ul", {className: "modal-order-task-list container-fluid"}, 
                            brewingTasks
                        )
                    )
                )
            );
            tabsContent = (
                React.createElement(Tabs, {className: "modal-order-dialog", 
                      ref: "refTabs", 
                      initialSelectedIndex: currentTabOpen}, 
                    React.createElement(Tab, {onActive: this.props.onActiveFirstTab, label: t('dashboard_modal_tab_general')}, 
                        React.createElement("div", {className: "modal-order-container fluid-container"}, 
                            bodyContent
                        )
                    ), 
                    brewingTab, 
                    React.createElement(Tab, {onActive: this.props.onActiveFirstTab, label: this.props.sectionName}, 
                        React.createElement("div", {className: "modal-order-task-container container-fluid"}, 
                            React.createElement("ul", {className: "modal-order-task-list container-fluid"}, 
                                tasks
                            )
                        )
                    )
                )
            );
        }

        return tabsContent;
    }
});

function isSingleFromBrewingSection(state) {
    return get(state, 'order.isSingle') && get(state, 'sectionName') === 'Brewing';
}

module.exports = DashboardModalSingleChange;




/** WEBPACK FOOTER **
 ** ./src/components/DashboardModal/DashboardModalSingle/DashboardModalSingleChange.jsx
 **/